<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
      </div>
      @if (dataLoaded()) {
        <div class="col-lg-7 col-xs-12 content">
          <p class="paragraph">{{ message() }}</p>
          @if (requestType() !== "SAV") {
            <p class="paragraph">À très bientôt.</p>
          }
          <div class="buttons">
            <app-button
              [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
              [theme]="'WHITE'"
              [url]="'/projets'"
              class="button"
              label="Les intérieurs de nos clients" />
            <app-button
              [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
              [theme]="'TRANSPARENT_WHITE'"
              [url]="'/charte-dengagements-perene'"
              label="Notre charte d'engagement" />
          </div>
        </div>
      }
    </div>
  </div>
</section>
